import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type OrganizationWorkflowRestorationFailedAction = {
	type: 'ORGANIZATION_WORKFLOW_RESTORATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): OrganizationWorkflowRestorationFailedAction => ({
	type: 'ORGANIZATION_WORKFLOW_RESTORATION_FAILED',
	payload,
});
